import React, { useState } from "react";

import ICON_ARROW from "../assets/arrow.svg";
import Status, { TypeStatusProps } from "./Status";

interface TypeCollapseProps extends Partial<Pick<TypeStatusProps, "status">> {
  title: string;
  className?: string;
  defaultValue?: boolean;
  children?: React.ReactNode;
}

/**
 * @name Collapse 展开收起面板
 */
const Collapse: React.FC<TypeCollapseProps> = ({
  title,
  status,
  children,
  defaultValue,
  className = "",
}) => {
  const [open, setOpen] = useState(defaultValue);

  const borderBottom = `1px solid ${open ? "#DBDCDE" : "transparent"}`;

  return (
    <div
      style={{ height: open ? "auto" : 56 }}
      className={`website-collapse ${className}`}
    >
      <div
        style={{ borderBottom }}
        onClick={() => setOpen((b) => !b)}
        className="website-collapse-header"
      >
        <h5>{title}</h5>
        <div>
          {status ? <Status status={status} /> : null}
          <img
            src={ICON_ARROW}
            style={{ transform: open ? "rotate(180deg)" : undefined }}
          />
        </div>
      </div>
      <div className="website-collapse-ctx">{children}</div>
    </div>
  );
};

export default Collapse;
